module.exports = __webpack_public_path__ + "assets/6c9414c155469be3d197551d915c0df7.mp3";